import styled from "styled-components"
import media from "styled-media-query"

const QText = styled.p`
  font-size: 4.27vw;
  font-weight: 700;
  line-height: 7.2vw;
  margin: 0;
  ${media.greaterThan("small")`
    font-size: 22px;
    height: 6em;
    line-height: normal;
    margin: 22px 0 0 0;
  `}
`

export default QText
